const EVENT = "marsilya-mascot";

export const MASCOT = {
  hello: "/mascot/hello.webp",
  ok: "/mascot/ok.webp",
  win: "/mascot/win.webp",
  thanks: "/mascot/thanks.webp",
  tease: "/mascot/tease.webp",
  chill: "/mascot/chill.webp",
  sad: "/mascot/sad.webp",
};

export function mascotSrc(mood) {
  return MASCOT[mood] || MASCOT.hello;
}

export function showMascot(detail) {
  if (typeof window === "undefined" || !detail) return;
  window.dispatchEvent(new CustomEvent(EVENT, { detail }));
}

export function subscribeMascot(handler) {
  const listener = (event) => handler(event.detail || {});
  window.addEventListener(EVENT, listener);
  return () => window.removeEventListener(EVENT, listener);
}
